export default __webpack_public_path__ + "static/media/nature-man.e557192e.svg";